import React, { useEffect, useState } from 'react';
import Avatar from '../../assets/images/profile.png';
import { getUserInfo } from '../../utils/token';
import { getCompanyDetails } from '../../api/endpoints/company';
import {getCustomerDetails} from '../../api/endpoints/customer';
import {getAdminDetails} from '../../api/endpoints/admin';
import ProfileInfo from './ProfileInfo';
import  PasswordChangeModal  from '../modals/forms/PasswordChangeModal';
import { changePasscode } from '../../api/endpoints/auth';
import showErrorAlert from '../../utils/swalAlerts/showErrorAlert';
import showSuccessAlert from '../../utils/swalAlerts/showSuccessAlert';

const Profile = () => {
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [userId, setUserId] = useState(getUserInfo().userId);
  const [role, setRole] = useState(getUserInfo().role);
  const [userDetails, setUserDetails] = useState({
    fullname: "",
    mobile: "",
    email: "",
    location: "",
  });

  useEffect(()=>{
    const {userId, role} = getUserInfo();
    let userDetails = {}
    async function fetchData() {
      switch (role) {
        case "Admin":
          userDetails = await getAdminDetails(userId);
          setUserDetails({
            fullname: userDetails.data.data.first_name + " " + userDetails.data.data.last_name,
            mobile: userDetails.data.data.mobile,
            email: userDetails.data.data.email_id,
            location: "--",
          })
          break;
        case "Company":
          userDetails = await getCompanyDetails(userId);
          setUserDetails({
            fullname: userDetails.data.data.company_name,
            mobile: userDetails.data.data.comp_mobile,
            email: userDetails.data.data.email_id,
            location: userDetails.data.data.address,
          })
          break;
        case "Customer":
          userDetails = await getCustomerDetails(userId);
          setUserDetails({
            fullname: userDetails.data.data.customer_first_name + " " + userDetails.data.data.customer_last_name,
            mobile: userDetails.data.data.customer_mobile,
            email: userDetails.data.data.email_id,
            location: userDetails.data.data.customer_address,
          })
          break;
        default:
          break;
      }

    }
    fetchData();

  },[])

  const handlePasswordSave = async (newPassword) => {
    console.log(newPassword);
    
    const response = await changePasscode(userId, role, btoa(newPassword));
    if(response.data.success){
      showSuccessAlert({
        title: "Password Change Status",
        message: response.data.message,
        icon: "success",
        cancelText : 'Ok',
      })
    }else{
      showErrorAlert({
        title: "Oops...! Something went Wrong !",
        message: "Please try after sometime.",
        icon: "error",
      })
    }
    setShowPasswordModal(false);
  };

  return (
      <div className="container-fluid">
        <div className="profile-foreground position-relative mx-n4 mt-n4">
          <div className="profile-wid-bg">
            <img src="/assets/images/profile-bg.jpg" alt="" className="profile-wid-img" />
          </div>
        </div>

        <div className="pt-4 mb-4 mb-lg-3 pb-lg-4 profile-wrapper">
          <div className="row g-4">
            <div className="col-auto">
              <div className="avatar-lg">
                <img src={Avatar} alt="user-img" className="img-thumbnail rounded-circle" />
              </div>
            </div>

            <div className="col">
              <div className="p-2">
                <h3 className="text-white mb-1">{userDetails.fullname}</h3>
                <p className="text-white text-opacity-75"></p>
                <div className="hstack text-white-50 gap-1">
                  <div className="me-2">
                    <i className="ri-map-pin-user-line me-1 text-white text-opacity-75 fs-16 align-middle"></i>
                    {userDetails.location}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-auto order-last order-lg-0">
              <div className="row text text-white-50 text-center">
                {/*
                <div className="col-lg-6 col-4">
                  <div className="p-2">
                    <h4 className="text-white mb-1">24.3K</h4>
                    <p className="fs-14 mb-0">Followers</p>
                  </div>
                </div>
                <div className="col-lg-6 col-4">
                  <div className="p-2">
                    <h4 className="text-white mb-1">1.3K</h4>
                    <p className="fs-14 mb-0">Following</p>
                  </div>
                </div>
                */}
              </div>
            </div>
          </div>
        </div>

        {/* Tabs and Content */}
        <div className="row">
          <div className="col-lg-12">
            <div>
              <div className="d-flex profile-wrapper">
                <ul className="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1" role="tablist">
                  <li className="nav-item">
                    <a className="nav-link fs-14 active" data-bs-toggle="tab" href="#overview-tab" role="tab">
                      <i className="ri-airplay-fill d-inline-block d-md-none"></i>
                      <span className="d-none d-md-inline-block">Overview</span>
                    </a>
                  </li>
                </ul>
                <div className="flex-shrink-0">
                  <button className="btn btn-danger" onClick={() => setShowPasswordModal(true)}>
                    <i className="ri-lock-password-line align-bottom"></i> Change Password
                  </button>
                </div>
              </div>

              <ProfileInfo  fullName={userDetails.fullname} mobile={userDetails.mobile} email={userDetails.email} location={userDetails.location}/>
            </div>
          </div>
        </div>
        <PasswordChangeModal
        show={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
        onSave={handlePasswordSave}
      />
      </div>
      
  );
};

export default Profile;
